import { companyApiService } from 'service/api/companyApiService';
import { accountStore } from 'store/accountStore';
import { CompanyInterface } from 'type/companyType';

export class ContentProviderService {
  public async create(company: CompanyInterface): Promise<void> {
    const user = accountStore.getAccount();
    const newCompany: CompanyInterface = {
      id: -1,
      title: company.title,
      description: company.description,
      title_en: company.title_en || '',
      slug: company.slug || '',
      country: company.country || '',
      platform_id: user?.platform.id || 1,
      person_in_charge: company.person_in_charge || null,
      person_in_charge_email_address: company.person_in_charge_email_address || null,
      // 폼 값을 골라 담는 구조라 새 필드를 여기 추가하지 않으면 조용히 버려진다.
      // 실제로 이 누락 때문에 생성 시 토글을 켜도 항상 false 로 저장됐다
      // (update 는 스프레드라 정상 동작했다).
      is_lg_channel_vietnam: Boolean(company.is_lg_channel_vietnam),
    };
    await companyApiService.create(newCompany);
  }

  public async update(id: number, company: CompanyInterface): Promise<void> {
    const user = accountStore.getAccount();
    await companyApiService.update(Number(id), {
      ...company,
      title_en: company.title_en || undefined,
      slug: company.slug || undefined,
      country: company.country || undefined,
      platform_id: user?.platform.id || 1,
      person_in_charge: company.person_in_charge || null,
      person_in_charge_email_address: company.person_in_charge_email_address || null,
    });
  }

  public async fetchContentProvider(
    params: URLSearchParams
  ): Promise<{ data: CompanyInterface[]; count: number }> {
    const contentProviderList = await companyApiService.fetch(params);
    return {
      data: contentProviderList.results,
      count: contentProviderList.count,
    };
  }
}

export const contentProviderService = new ContentProviderService();
